import {isNumber} from "lodash";

export class CsvHelper {
    static encodeString(item) {
        if (isNumber(item)) {
            return item;
        }

        // помогает при наличии в строке знаков ";" и "\n", но в самом файле строки оборачиваются в кавычки
        return '"' + item.replaceAll('"', '""') + '"';
    }
}
